import { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { getNewsById, formatDate, NEWS_CATEGORY_LABELS } from '../services/newsService'
import type { News } from '../types'

const NewsDetailPage = () => {
  const { id } = useParams<{ id: string }>()
  const [news, setNews] = useState<News | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    async function fetchNews() {
      if (!id) return

      try {
        setLoading(true)
        const data = await getNewsById(id)
        setNews(data)
      } catch (err) {
        setError(err as Error)
        console.error('Failed to fetch news:', err)
      } finally {
        setLoading(false)
      }
    }

    fetchNews()
  }, [id])

  const breadcrumbs = news
    ? [
        { label: 'ホーム', to: '/' },
        { label: 'お知らせ', to: '/#news' },
        { label: news.title },
      ]
    : [{ label: 'ホーム', to: '/' }]

  if (loading) {
    return (
      <>
        <Header breadcrumbs={breadcrumbs} />
        <main>
          <section className="article-detail">
            <div className="container">
              <p style={{ textAlign: 'center', padding: '4rem 0' }}>読み込み中...</p>
            </div>
          </section>
        </main>
        <Footer />
      </>
    )
  }

  if (error || !news) {
    return (
      <>
        <Header breadcrumbs={breadcrumbs} />
        <main>
          <section className="article-detail">
            <div className="container">
              <p style={{ textAlign: 'center', padding: '4rem 0' }}>
                お知らせが見つかりませんでした
              </p>
              <div style={{ textAlign: 'center' }}>
                <Link to="/" className="btn btn-outline">
                  ホームに戻る
                </Link>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </>
    )
  }

  return (
    <>
      <Header breadcrumbs={breadcrumbs} />
      <main>
        <section className="article-detail">
          <div className="container">
            <article className="article-content">
              <header className="article-header">
                <div className="article-meta">
                  <span className="article-date">{formatDate(news.publishDate)}</span>
                  <span className="article-category">
                    {NEWS_CATEGORY_LABELS[news.category]}
                  </span>
                </div>
                <h1 className="article-title">{news.title}</h1>
              </header>

              <div
                className="article-body"
                dangerouslySetInnerHTML={{ __html: news.content }}
              />

              <footer className="article-footer">
                <div className="article-back">
                  <Link to="/#news" className="btn btn-outline">
                    一覧に戻る
                  </Link>
                </div>
              </footer>
            </article>
          </div>
        </section>
      </main>
      <Footer />
    </>
  )
}

export default NewsDetailPage

